import classNames from 'classnames';
import { RemovableElementContext } from 'components/common-form/contexts/RemovableElementContext';
import { useFormatFormGroupLabel } from 'components/shared/FormGroup/useFormatFormGroupLabel';
import { useContext } from 'react';
import styled from 'styled-components';

import type { DefaultOrientationFormGroupProps } from './model';

const StyledDiv = styled.div`
  & > * {
    width: 100%;
  }
`;

export function RemovableListItemFormGroup({
  children,
  className,
  inputId,
  workspaceType,
  label,
  updateActions,
  contentPosition = 'side',
}: DefaultOrientationFormGroupProps) {
  const formatLabel = useFormatFormGroupLabel(workspaceType);
  const isSideContent = contentPosition === 'side';
  const { onRemove } = useContext(RemovableElementContext);
  const fieldLabel = (
    <div className="d-flex justify-content-between w-100 align-items-center">
      <div className="me-2 mb-0 text-secondary d-flex align-items-center">
        <button className="btn btn-icon text-secondary pe-3" onClick={() => onRemove(inputId)}>
          <i className="icon">cancel</i>
        </button>
        {formatLabel({ inputId, label })}
      </div>
      {updateActions}
    </div>
  );
  const content = (
    <StyledDiv
      className={classNames('w-100  justify-content-between align-items-start my-2', className, {
        'mx-3': isSideContent,
      })}
    >
      {children}
    </StyledDiv>
  );
  return isSideContent ? (
    <>
      {fieldLabel}
      {content}
    </>
  ) : (
    <div className="d-flex w-100 flex-wrap">
      <div className="d-flex w-100">{fieldLabel}</div>
      <div className="ms-3 ps-3 d-flex w-100"> {content}</div>
    </div>
  );
}
